(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-gallery-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gallery-hero')) {
    const EASE = 'cubic-bezier(.2,.7,.1,1)';

    class GalleryHero extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.gallery-hero__slide')];
        this.progress = this.querySelector('[data-progress]');
        this.captionLink = this.querySelector('[data-caption-link]');
        this.captionText = this.querySelector('[data-caption-text]');
        this.count = this.querySelector('[data-count]');
        this.toggle = this.querySelector('[data-toggle]');
        this.interval = Number(this.dataset.interval) || 5000;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.current = 0;
        this.elapsed = 0;
        this.visible = false;
        // Reduced motion: never advance on its own, the controls still work
        this.stopped = this.reduceMotion;

        this.setupMore();
        this.setupBrowse();
        if (this.slides.length < 2) return;

        this.toggle?.addEventListener('click', () => this.setStopped(!this.stopped));
        this.updateToggle();

        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
        });
        this.observer.observe(this);

        this.last = performance.now();
        this.frame = requestAnimationFrame((time) => this.tick(time));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
      }

      get running() {
        return !this.stopped && this.visible && !document.hidden;
      }

      tick(time) {
        const delta = time - this.last;
        this.last = time;
        if (this.running) {
          this.elapsed += delta;
          if (this.elapsed >= this.interval) this.go((this.current + 1) % this.slides.length);
        }
        if (this.progress) {
          this.progress.style.transform = `scaleX(${Math.min(this.elapsed / this.interval, 1)})`;
        }
        this.frame = requestAnimationFrame((next) => this.tick(next));
      }

      go(index) {
        const incoming = this.slides[index];
        const outgoing = this.slides[this.current];
        this.elapsed = 0;
        if (incoming === outgoing) return;

        this.slides.forEach((slide) => {
          slide.getAnimations().forEach((animation) => animation.cancel());
          slide.classList.remove('is-leaving');
        });
        outgoing.classList.remove('is-active');
        outgoing.classList.add('is-leaving');
        incoming.classList.add('is-active');

        const done = () => outgoing.classList.remove('is-leaving');
        if (this.reduceMotion) {
          done();
        } else {
          outgoing.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 1400, easing: EASE });
          incoming.animate(
            [{ opacity: 0, transform: 'scale(1.08)' }, { opacity: 1, transform: 'scale(1)' }],
            { duration: 1400, easing: EASE }
          ).onfinish = done;
        }

        this.current = index;
        this.updateCaption(incoming, index);
      }

      updateCaption(slide, index) {
        const text = slide.dataset.name;
        if (this.captionLink) {
          if (slide.hasAttribute('href')) this.captionLink.href = slide.getAttribute('href');
          else this.captionLink.removeAttribute('href');
        }
        if (this.count) this.count.textContent = `${index + 1} / ${this.slides.length}`;
        if (!this.captionText) return;
        if (this.reduceMotion) {
          this.captionText.textContent = text;
          return;
        }
        // Masked line rise: old text leaves upwards, new text rises in
        this.captionText.animate([{ transform: 'none' }, { transform: 'translateY(-105%)' }], {
          duration: 280,
          easing: 'ease-in',
          fill: 'forwards',
        }).onfinish = () => {
          this.captionText.textContent = text;
          this.captionText.animate([{ transform: 'translateY(105%)' }, { transform: 'none' }], {
            duration: 520,
            easing: EASE,
            fill: 'forwards',
          });
        };
      }

      setStopped(stopped) {
        this.stopped = stopped;
        this.updateToggle();
      }

      updateToggle() {
        if (!this.toggle) return;
        this.toggle.classList.toggle('is-paused', this.stopped);
        this.toggle.setAttribute('aria-label', this.stopped ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
      }

      setupMore() {
        const button = this.querySelector('[data-more-toggle]');
        const panel = this.querySelector('[data-more]');
        if (!button || !panel) return;
        button.addEventListener('click', () => {
          const open = panel.classList.toggle('is-open');
          button.setAttribute('aria-expanded', open);
          button.textContent = open ? button.dataset.labelLess : button.dataset.labelMore;
        });
      }

      setupBrowse() {
        const link = this.querySelector('[data-browse]');
        if (!link) return;
        link.addEventListener('click', (event) => {
          const grid = document.getElementById('ProductGridContainer');
          if (!grid) return;
          event.preventDefault();
          // Land on the whole grid section so the filter bar stays in view
          const target = grid.closest('.shopify-section') || grid;
          const header = document.querySelector('.section-header');
          const offset = header && getComputedStyle(header).position === 'sticky' ? header.offsetHeight : 0;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top, behavior: this.reduceMotion ? 'auto' : 'smooth' });
        });
      }
    }

    customElements.define('gallery-hero', GalleryHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-previews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-previews')) {
    // Hovering (or focusing) a product thumbnail slides that product into
    // the card's cover; leaving the row slides it back out. One instance per
    // card, pointer devices only.
    //
    // Motion is a parallax push: the image on top travels the full width
    // while the one underneath drifts DRIFT% the same way. The cover counts
    // as the slot before the first product, so entering travels right and
    // leaving travels back; between products the slide follows the row.
    //
    // Interruptions: a new hover finishes whatever is in flight (end state
    // applied instantly) and starts from there. The one exception is hovering
    // the product that is currently sliding out, which reverses it in place.
    class CoverPreview {
      static DRIFT = 30;
      static TIMING = { duration: 460, easing: 'cubic-bezier(0.32, 0.72, 0, 1)' };
      // How long a hover may wait for the full-size file before showing the
      // (blurry, upscaled) thumbnail as a stand-in.
      static DECODE_WAIT = 120;

      constructor(item) {
        this.item = item;
        this.media = item.querySelector('.collection-previews__cover-media');
        this.cover = this.media.querySelector('.collection-previews__cover-image');
        this.title = item.querySelector('.collection-previews__name');
        this.caption = item.querySelector('.collection-previews__caption');
        this.products = [...item.querySelectorAll('.collection-previews__product[data-cover-src]')];
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.layers = new Map(); // product -> preview <img>
        this.files = new Map(); // product -> Promise<src | null>
        this.ready = new Map(); // product -> decoded src
        this.current = null; // product shown in the cover
        this.exiting = false;
        this.running = []; // in-flight animations
        this.onSettled = null; // end state for `running`
        this.token = 0; // invalidates pending decode waits

        this.bind();
      }

      bind() {
        const list = this.item.querySelector('.collection-previews__products');
        const more = this.item.querySelector('.collection-previews__more');

        this.products.forEach((product) => {
          product.addEventListener('pointerenter', () => this.show(product));
          product.addEventListener('focus', () => this.show(product));
        });
        list.addEventListener('pointerleave', () => this.hide());
        list.addEventListener('focusout', (event) => {
          if (!list.contains(event.relatedTarget)) this.hide();
        });
        if (more) {
          more.addEventListener('pointerenter', () => this.hide());
          more.addEventListener('focus', () => this.hide());
        }
      }

      // Kick off every full-size file for this card.
      preload() {
        this.products.forEach((product) => this.load(product));
      }

      // Packshots are square and fill the portrait cover (object-fit: cover),
      // so they render as wide as the cover is tall: size from the longer side.
      fileFor(product) {
        const { width, height } = this.media.getBoundingClientRect();
        const pixels = Math.max(width, height) * (window.devicePixelRatio || 1);
        const size = Math.min(1600, Math.max(400, Math.ceil(pixels / 100) * 100));
        return product.dataset.coverSrc.replace(/([?&])width=\d+/, `$1width=${size}`);
      }

      load(product) {
        if (!this.files.has(product)) {
          const image = new Image();
          image.src = this.fileFor(product);
          this.files.set(
            product,
            image.decode().then(
              () => {
                this.ready.set(product, image.src);
                return image.src;
              },
              () => null
            )
          );
        }
        return this.files.get(product);
      }

      layerFor(product) {
        if (this.layers.has(product)) return this.layers.get(product);

        const layer = document.createElement('img');
        layer.className = 'collection-previews__image collection-previews__preview';
        layer.alt = '';
        layer.decoding = 'sync';
        if (this.ready.has(product)) {
          layer.src = this.ready.get(product);
        } else {
          const thumb = product.querySelector('img');
          if (thumb && thumb.currentSrc) layer.src = thumb.currentSrc;
          this.load(product).then((src) => {
            if (src) layer.src = src;
          });
        }
        this.layers.set(product, layer);
        return layer;
      }

      async show(product) {
        const token = ++this.token;
        if (!this.ready.has(product)) {
          await Promise.race([this.load(product), new Promise((resolve) => setTimeout(resolve, CoverPreview.DECODE_WAIT))]);
          if (token !== this.token) return; // the pointer moved on
        }

        if (this.exiting && product === this.current) {
          this.reverseExit();
          return;
        }

        this.settle();
        const from = this.current;
        if (from === product) return;

        const incoming = this.layerFor(product);
        const outgoing = from ? this.layers.get(from) : this.cover;
        const direction = from && this.products.indexOf(product) < this.products.indexOf(from) ? -1 : 1;

        this.media.append(incoming); // on top of whatever is showing
        incoming.classList.add('is-visible');
        this.caption.textContent = product.dataset.title;
        this.item.classList.add('is-previewing');
        this.current = product;

        this.run(
          [
            [incoming, `translateX(${direction * 100}%)`, 'none'],
            [outgoing, 'none', `translateX(${-direction * CoverPreview.DRIFT}%)`],
            from ? null : [this.title, 'none', `translateX(${-this.titleShift()}px)`],
          ],
          () => {
            if (from) outgoing.classList.remove('is-visible');
          }
        );
      }

      hide() {
        this.token++;
        if (!this.current || this.exiting) return;

        this.settle();
        const outgoing = this.layers.get(this.current);
        this.exiting = true;
        this.item.classList.remove('is-previewing');

        this.run(
          [
            [outgoing, 'none', 'translateX(100%)'],
            [this.cover, `translateX(${-CoverPreview.DRIFT}%)`, 'none'],
            [this.title, `translateX(${-this.titleShift()}px)`, 'none'],
          ],
          () => {
            outgoing.classList.remove('is-visible');
            this.current = null;
            this.exiting = false;
          }
        );
      }

      reverseExit() {
        const animations = this.running;
        animations.forEach((animation) => animation.reverse());
        this.exiting = false;
        this.item.classList.add('is-previewing');
        // Same animations, new end state: the product simply stays.
        this.track([...animations], () => {});
      }

      // The title rides with the cover image; its drift is the cover's, in px.
      titleShift() {
        return this.media.offsetWidth * (CoverPreview.DRIFT / 100);
      }

      // Animate `[element, from, to]` transforms together, or jump straight to
      // the end state when motion is reduced.
      run(steps, onSettled) {
        if (this.reduceMotion.matches) {
          onSettled();
          return;
        }
        const animations = steps
          .filter((step) => step && step[0])
          .map(([element, from, to]) => element.animate([{ transform: from }, { transform: to }], CoverPreview.TIMING));
        this.track(animations, onSettled);
      }

      track(animations, onSettled) {
        this.running = animations;
        this.onSettled = onSettled;
        Promise.all(animations.map((animation) => animation.finished)).then(
          () => {
            if (this.running === animations) this.settle();
          },
          () => {} // cancelled by settle(); its end state has been applied
        );
      }

      // Apply the end state of whatever is in flight, instantly.
      settle() {
        const { running, onSettled } = this;
        this.running = [];
        this.onSettled = null;
        running.forEach((animation) => animation.cancel());
        if (onSettled) onSettled();
      }
    }

    class CollectionPreviews extends HTMLElement {
      connectedCallback() {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

        // Start fetching a card's full-size files the moment the pointer
        // reaches that card, ahead of its first thumbnail hover. Only cards the
        // visitor actually points at download anything.
        this.querySelectorAll('.collection-previews__item').forEach((item) => {
          if (!item.querySelector('.collection-previews__product[data-cover-src]')) return;
          const preview = new CoverPreview(item);
          item.addEventListener('pointerenter', () => preview.preload(), { once: true });
        });
      }
    }

    customElements.define('collection-previews', CollectionPreviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["designer-profile"]) return;
  try {
    
  if (!customElements.get('designer-bio')) {
    class DesignerBio extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.designer-hero__more');
        if (!this.button) return;
        this.button.addEventListener('click', () => {
          const open = this.toggleAttribute('open');
          this.querySelector('.designer-hero__bio-more')?.toggleAttribute('inert', !open);
          this.button.setAttribute('aria-expanded', open);
          this.button.textContent = open ? this.button.dataset.labelLess : this.button.dataset.labelMore;
        });
      }
    }
    customElements.define('designer-bio', DesignerBio);
  }

  if (!customElements.get('designer-index')) {
    class DesignerIndex extends HTMLElement {
      async connectedCallback() {
        if (this.dataset.src) {
          try {
            const response = await fetch(this.dataset.src);
            const html = await response.text();
            const section = new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('.shopify-section');
            this.innerHTML = section ? section.innerHTML : '';
          } catch (error) {
            this.innerHTML = '';
          }
          this.removeAttribute('aria-busy');
          if (!this.querySelector('.designer-index__row')) {
            this.hidden = true;
            return;
          }
        }
        this.addEventListener(
          'scroll',
          (event) => {
            const track = event.target;
            if (!track.classList?.contains('designer-index__track')) return;
            track.parentElement.dataset.slide = Math.round(track.scrollLeft / track.clientWidth);
          },
          { capture: true, passive: true }
        );
        this.scene = this.querySelector('.designer-index__scene');
        this.pack = this.querySelector('.designer-index__pack img');
        this.captionTitle = this.querySelector('.designer-index__caption-title');
        this.stage = this.querySelector('.designer-index__stage');
        this.price = this.querySelector('.designer-index__caption-price');
        if (!this.scene) return;
        const select = (event) => {
          const row = event.target.closest('.designer-index__row');
          if (!row) return;
          this.setAttribute('data-engaged', '');
          this.select(row);
        };
        this.addEventListener('pointerover', select);
        this.addEventListener('focusin', select);
      }

      select(row) {
        if (row.classList.contains('is-active')) return;
        this.querySelector('.designer-index__row.is-active')?.classList.remove('is-active');
        row.classList.add('is-active');
        this.scene.src = row.dataset.scene;
        this.pack.src = row.dataset.pack;
        this.captionTitle.textContent = row.dataset.title;
        this.stage.href = row.href;
        this.price.innerHTML = row.querySelector('.designer-index__price').innerHTML;
      }
    }
    customElements.define('designer-index', DesignerIndex);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["designers-stage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('designers-stage')) {
    customElements.define(
      'designers-stage',
      class DesignersStage extends HTMLElement {
        connectedCallback() {
          this.slides = [...this.querySelectorAll('.designers-stage__slide')];
          this.names = [...this.querySelectorAll('.designers-stage__name')];
          this.bios = [...this.querySelectorAll('.designers-stage__bio')];
          if (this.slides.length < 2) return;

          this.index = 0;
          this.timer = this.querySelector('.designers-stage__timer');
          this.autoplay =
            this.dataset.autoplay === 'true' &&
            this.timer &&
            !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.paused = false;

          this.timer?.addEventListener('animationend', () => this.show(this.index + 1));
          this.timer?.addEventListener('click', () => this.setPaused(!this.paused));

          this.names.forEach((name) =>
            name.addEventListener('mouseenter', () => this.show(Number(name.dataset.index)))
          );
          this.querySelectorAll('[data-step]').forEach((button) =>
            button.addEventListener('click', () => this.step(Number(button.dataset.step)))
          );

          this.addEventListener('touchstart', (event) => (this.touchX = event.touches[0].clientX), { passive: true });
          this.addEventListener(
            'touchend',
            (event) => {
              const dx = event.changedTouches[0].clientX - this.touchX;
              if (Math.abs(dx) > 40) this.step(dx < 0 ? 1 : -1);
            },
            { passive: true }
          );

          // Only rotate while the stage is on screen.
          this.observer = new IntersectionObserver(([entry]) => {
            this.timer?.classList.toggle('is-offscreen', !entry.isIntersecting);
          });
          this.observer.observe(this);
          this.restartRing();

          document.addEventListener('shopify:block:select', this.onBlockSelect);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        onBlockSelect = (event) => {
          const index = this.slides.findIndex((slide) => slide.contains(event.target));
          if (index > -1) {
            this.setPaused(true);
            this.show(index);
          }
        };

        show(index) {
          const count = this.slides.length;
          this.index = (index + count) % count;
          this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
          this.bios.forEach((bio) => bio.classList.toggle('is-active', Number(bio.dataset.index) === this.index));
          this.names.forEach((name, i) => {
            if (i === this.index) name.setAttribute('aria-current', 'true');
            else name.removeAttribute('aria-current');
          });
          this.restartRing();
        }

        step(direction) {
          this.show(this.index + direction);
        }

        // Restart the ring for the designer now on stage.
        restartRing() {
          if (!this.autoplay) return;
          this.timer.classList.remove('is-running');
          void this.timer.offsetWidth;
          this.timer.classList.add('is-running');
        }

        setPaused(value) {
          if (!this.autoplay) return;
          this.paused = value;
          this.timer.classList.toggle('is-paused', value);
          this.timer.setAttribute('aria-label', value ? this.timer.dataset.labelPlay : this.timer.dataset.labelPause);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      // Mobile-only transparent mode: sync the markup with the current layout
      // here too, not just in the inline pre-paint script, in case the element
      // connects before that script runs (e.g. a theme editor re-render).
      if (this.dataset.transparentMobileOnly) {
        this.desktopQuery = window.matchMedia('(min-width: 990px)');
        this.toggleTransparentClasses(!this.desktopQuery.matches);
      }
      this.isTransparent = this.hasAttribute('data-transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.onResizeHandler = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.setHeaderHeight(), 150);
      };
      window.addEventListener('resize', this.onResizeHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      // Back/forward cache restores the page mid-scroll without a scroll event.
      this.onPageShowHandler = (event) => {
        if (event.persisted) this.syncScrollState();
      };
      window.addEventListener('pageshow', this.onPageShowHandler);

      this.createObserver();

      if (this.isTransparent) {
        this.initTransparent();
      }

      if (this.desktopQuery) {
        this.onDesktopChange = () => this.setTransparentMode(!this.desktopQuery.matches);
        this.desktopQuery.addEventListener('change', this.onDesktopChange);
      }
    }

    // Mobile-only transparent mode: toggle the transparent styling in place
    // when the layout crosses the desktop breakpoint.
    setTransparentMode(enabled) {
      if (enabled === this.isTransparent) return;
      this.isTransparent = enabled;
      // Snap the padding change so the measured height is the final one.
      this.header.classList.add('section-header--measuring');
      this.toggleTransparentClasses(enabled);

      if (enabled) {
        this.initTransparent();
        if (this.header.classList.contains('scrolled-past-header')) this.classList.add('header-wrapper--opaque');
        this.updateTransparentState();
      } else {
        this.transparentObservers?.forEach((observer) => observer.disconnect());
        this.transparentObservers = [];
        this.cancelUnderlayFade();
        this.classList.remove('header-wrapper--opaque');
        this.style.removeProperty('--header-underlay-height');
      }

      this.setHeaderHeight();
      this.header.offsetHeight;
      this.header.classList.remove('section-header--measuring');
    }

    toggleTransparentClasses(enabled) {
      this.toggleAttribute('data-transparent-header', enabled);
      this.classList.toggle('header-wrapper--transparent', enabled);
      this.classList.toggle(this.dataset.transparentMobileOnly, enabled);
    }

    initTransparent() {
      const wrapper = this;
      this.transparentObservers = [];
      const menus = this.querySelectorAll('details.mega-menu');

      menus.forEach((details) => {
        const observer = new MutationObserver(() => {
          requestAnimationFrame(() => wrapper.updateTransparentState());
        });
        observer.observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
        this.transparentObservers.push(observer);
      });

      const drawerDetails = this.querySelector('#Details-menu-drawer-container');
      if (drawerDetails) {
        const observer = new MutationObserver(() => {
          requestAnimationFrame(() => wrapper.updateTransparentState());
        });
        observer.observe(drawerDetails, { attributes: true, attributeFilter: ['open', 'class'] });
        this.transparentObservers.push(observer);
      }
    }

    updateTransparentState() {
      const scrolled = this.header.classList.contains('scrolled-past-header');
      const openMenu = this.querySelector('details.mega-menu[open]:not(.menu-closing)');
      const closingMenu = this.querySelector('details.mega-menu[open].menu-closing');
      // The logo-left bottom sheet rises over a scrim and leaves the bar as it
      // is; only the drop-down drawer needs the bar opaque above it.
      const drawerOpen =
        this.querySelector('#Details-menu-drawer-container[open]') &&
        !(this.querySelector('.header--mobile-left') && window.matchMedia('(max-width: 989px)').matches);

      if (drawerOpen) {
        this.cancelUnderlayFade();
        this.style.setProperty('--header-underlay-height', '100%');
        this.classList.add('header-wrapper--opaque');
      } else if (openMenu) {
        this.cancelUnderlayFade();
        const content = openMenu.querySelector('.mega-menu__content');
        // While switching panels the content is mid height-morph; its inline
        // height is the target, offsetHeight is only the current frame.
        const contentH = content ? parseFloat(content.style.height) || content.getBoundingClientRect().height : 0;
        // Measure from rects, not offsetHeight: the panel overlaps the bar by
        // 1px and the bar's own height is fractional, so integer maths leaves
        // the underlay's edge up to a pixel off the panel's edge.
        const contentTop = content ? content.getBoundingClientRect().top - this.getBoundingClientRect().top : this.offsetHeight;
        const fullH = contentTop + contentH;

        if (!this.classList.contains('header-wrapper--opaque')) {
          // Opening from the transparent state: cover the bar instantly, then
          // grow in step with the panel's top-down reveal. Growing from 0
          // would leave the bar see-through while the panel is already white.
          const underlay = this.querySelector('.header__underlay');
          underlay.style.transition = 'none';
          this.classList.add('header-wrapper--opaque');
          this.style.setProperty('--header-underlay-height', `${this.offsetHeight}px`);
          underlay.offsetHeight;
          underlay.style.transition = '';
        }

        this.style.setProperty('--header-underlay-height', `${fullH}px`);
        this.classList.add('header-wrapper--opaque');
      } else if (closingMenu) {
        // Stage 1: shrink to the bare bar height on the panel's own close
        // curve, so the underlay's edge and the panel's clipped edge travel
        // together. The bar stays opaque (and its text dark) throughout.
        this.style.setProperty('--header-underlay-height', `${this.offsetHeight}px`);
      } else if (!scrolled) {
        // Stage 2 (top of page): the panel is gone; fade the bar backdrop out
        // together with the text-color transition instead of collapsing it.
        if (this.classList.contains('header-wrapper--opaque')) this.startUnderlayFade();
        this.classList.remove('header-wrapper--opaque');
      } else {
        this.style.setProperty('--header-underlay-height', '100%');
      }
    }

    startUnderlayFade() {
      this.cancelUnderlayFade();
      this.style.setProperty('--header-underlay-height', `${this.offsetHeight}px`);
      this.classList.add('header-wrapper--underlay-fade');
      this.underlayFadeTimeout = setTimeout(() => {
        this.underlayFadeTimeout = null;
        this.cancelUnderlayFade();
      }, 300);
    }

    cancelUnderlayFade() {
      if (this.underlayFadeTimeout) {
        clearTimeout(this.underlayFadeTimeout);
        this.underlayFadeTimeout = null;
      }
      if (!this.classList.contains('header-wrapper--underlay-fade')) return;

      // Leaving the fade state returns the underlay to height 0 / opacity 1;
      // snap there, otherwise the height transition would slide the (now
      // visible again) bar backdrop up over 600ms.
      const underlay = this.querySelector('.header__underlay');
      underlay.style.transition = 'none';
      this.classList.remove('header-wrapper--underlay-fade');
      this.style.removeProperty('--header-underlay-height');
      underlay.offsetHeight;
      underlay.style.transition = '';
    }

    setHeaderHeight() {
      // The negative margin / --header-height must reflect the expanded
      // (top-of-page) header. When measuring while scrolled, lift the compact
      // state for the duration of this synchronous block — no frame is
      // painted in between, so nothing flashes on screen.
      const wasScrolled = this.header.classList.contains('scrolled-past-header');
      if (wasScrolled) {
        this.header.classList.add('section-header--measuring');
        this.header.classList.remove('scrolled-past-header');
      }

      if (this.isTransparent) {
        this.header.style.marginBottom = '';
        const height = Math.ceil(this.header.getBoundingClientRect().height);
        this.header.style.marginBottom = `-${height}px`;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      } else {
        this.header.style.marginBottom = '';
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      if (wasScrolled) {
        this.header.classList.add('scrolled-past-header');
        // Force a style/layout flush while transitions are still suppressed:
        // the compact values get committed without animating, and removing
        // the measuring class afterwards changes nothing visually.
        this.header.offsetHeight;
        this.header.classList.remove('section-header--measuring');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('pageshow', this.onPageShowHandler);
      clearTimeout(this.resizeTimer);
      this.desktopQuery?.removeEventListener('change', this.onDesktopChange);
      this.cancelUnderlayFade();
      if (this.transparentObservers) {
        this.transparentObservers.forEach((observer) => observer.disconnect());
        this.transparentObservers = [];
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
        this.syncScrollState();
      });

      observer.observe(this.header);
    }

    // onScroll() only runs on scroll events, so a page that arrives already
    // scrolled (reload with scroll restoration, an #anchor link, a bfcache
    // restore) kept the transparent header with no backdrop over the content.
    // Apply the state for the current position directly, without animating.
    syncScrollState() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isScrolledPast = this.header.classList.contains('scrolled-past-header');
      const shouldBeScrolledPast = scrollTop > this.headerBounds.bottom;
      const shouldBeAtTop = scrollTop <= this.headerBounds.top;
      this.currentScrollTop = scrollTop;

      if (shouldBeScrolledPast === isScrolledPast && !(shouldBeAtTop && isScrolledPast)) return;

      this.header.classList.add('section-header--measuring');

      if (shouldBeScrolledPast) {
        this.header.classList.add('scrolled-past-header');
        if (this.isTransparent) {
          this.classList.add('header-wrapper--opaque');
          this.updateTransparentState();
        }
      } else if (shouldBeAtTop) {
        this.header.classList.remove('scrolled-past-header');
        if (this.isTransparent && !this.querySelector('details.mega-menu[open]')) {
          this.classList.remove('header-wrapper--opaque');
        }
        this.reset();
      }

      // Flush styles while transitions are suppressed so the new state is
      // committed without animating.
      this.header.offsetHeight;
      this.header.classList.remove('section-header--measuring');
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Smooth scrolling eases toward its target asymptotically, so the last
      // pixels to the top take a long time. Treat a glide that is heading to
      // the top as already there, so the transparent state doesn't lag behind.
      const lenis = window.lenis;
      const glideTarget = lenis && lenis.isScrolling === 'smooth' ? lenis.targetScroll : scrollTop;
      const glidingToTop = scrollTop < this.currentScrollTop && glideTarget <= this.headerBounds.top;

      if (glidingToTop) {
        this.header.classList.remove('scrolled-past-header');
        if (this.isTransparent && !this.querySelector('details.mega-menu[open]')) {
          this.classList.remove('header-wrapper--opaque');
        }
        requestAnimationFrame(this.reset.bind(this));
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.isTransparent) {
          this.classList.add('header-wrapper--opaque');
          this.updateTransparentState();
        }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.isTransparent) {
          this.classList.add('header-wrapper--opaque');
          this.updateTransparentState();
        }
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (this.isTransparent && !this.querySelector('details.mega-menu[open]')) {
          this.classList.remove('header-wrapper--opaque');
        }
        requestAnimationFrame(this.reset.bind(this));
      }

      // The bar changes height as it leaves/enters the compact sticky state, so
      // an open mega menu's underlay (bar + panel) has to be re-measured after
      // the frame that applies the new state, or it ends up short of the panel.
      if (this.querySelector('details.mega-menu[open]:not(.menu-closing)')) {
        requestAnimationFrame(() => requestAnimationFrame(() => this.updateTransparentState()));
        // The bar's padding transition is still running on that frame; measure
        // once more after it has settled.
        window.clearTimeout(this.underlayResyncTimeout);
        this.underlayResyncTimeout = setTimeout(() => this.updateTransparentState(), 500);
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  if (!customElements.get('article-toc')) {
    customElements.define(
      'article-toc',
      class ArticleToc extends HTMLElement {
        connectedCallback() {
          const body = this.closest('.article-mag__layout')?.querySelector('.article-mag__body');
          this.tidyImageRows(body);
          const headings = body ? [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim()) : [];
          if (headings.length < 2) return;

          const list = this.querySelector('ol');
          this.links = headings.map((heading, index) => {
            if (!heading.id) heading.id = `section-${index + 1}`;
            const item = document.createElement('li');
            const link = document.createElement('a');
            link.href = `#${heading.id}`;
            link.textContent = heading.textContent.trim();
            link.title = link.textContent;
            link.addEventListener('click', (event) => {
              event.preventDefault();
              const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              heading.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
              history.replaceState(null, '', `#${heading.id}`);
            });
            item.append(link);
            list.append(item);
            return link;
          });
          this.hidden = false;

          // Ids only exist now, so a shared #section-n link could not jump on load.
          const target = location.hash && headings.find((heading) => `#${heading.id}` === location.hash);
          if (target) requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));

          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const index = headings.indexOf(entry.target);
                this.links.forEach((link, i) => link.classList.toggle('is-active', i === index));
              });
            },
            { rootMargin: '0px 0px -70% 0px' }
          );
          headings.forEach((heading) => this.observer.observe(heading));
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        // Editor content often pads side-by-side images with &nbsp; runs,
        // which would otherwise render as stray gaps in the image row.
        tidyImageRows(body) {
          if (!body) return;
          body.querySelectorAll('p').forEach((paragraph) => {
            // Empty paragraphs (often a trailing &nbsp; line) would add a
            // phantom gap after the last block.
            if (!paragraph.querySelector('img, iframe, video') && !paragraph.textContent.replace(/[\s\u00a0]/g, '')) {
              paragraph.remove();
              return;
            }
            if (!paragraph.querySelector('img')) return;
            const walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT);
            const empty = [];
            while (walker.nextNode()) {
              if (!walker.currentNode.textContent.replace(/[\s\u00a0]/g, '')) empty.push(walker.currentNode);
            }
            empty.forEach((node) => node.remove());
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-hero"] && !Shopify.designMode) return;
  try {
    
  class MediaHero extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video[data-autoplay]');
      if (!video) return;

      const play = () => video.play().catch(() => {});
      if (document.readyState === 'complete') {
        play();
      } else {
        window.addEventListener('load', play, { once: true });
      }
    }
  }

  if (!customElements.get('media-hero')) customElements.define('media-hero', MediaHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-desk"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-desk')) {
    class ProductDesk extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.product-desk__stage');
        this.track = this.querySelector('[data-track]');
        this.canvas = this.querySelector('[data-canvas]');
        this.bar = this.querySelector('[data-bar]');
        if (!this.canvas) return;

        // Touch screens scroll the track natively (see the stylesheet); the JS glide,
        // drag and parallax only run for mouse and trackpad
        this.native = window.matchMedia('(hover: none) and (pointer: coarse)').matches;

        this.items = [...this.canvas.querySelectorAll('.product-desk__item')];
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        // Position eases toward the target every frame; lower is smoother
        this.ease = this.reduceMotion ? 1 : 0.05;
        this.current = 0;
        this.target = 0;

        this.tick = this.tick.bind(this);
        // Mobile browsers fire resize as the toolbar collapses mid-scroll; writing
        // scrollLeft then would cut a native swipe short, so only the bar updates
        this.onResize = () => {
          if (this.native) {
            this.renderBar();
            return;
          }
          this.measure();
          this.setTarget(this.target);
        };

        this.layers = [];
        if (this.native) {
          this.bindNativeScroll();
        } else {
          this.bindDrag();
          this.bindWheel();
        }
        this.bindFocus();
        this.bindAlts();
        if (this.bar) this.bindBar();
        window.addEventListener('resize', this.onResize);

        // Measuring during parse would force a layout of the whole page, so the first
        // measure waits until the section is near. Off-canvas images never intersect on
        // their own either; load them all at the same moment.
        this.imageObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.canvas.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
          this.imageObserver.disconnect();
          this.measure();
          this.render();
        }, { rootMargin: '600px 0px' });
        this.imageObserver.observe(this);
      }

      // Hover photos only matter to a mouse or keyboard, so touch visits never download them
      bindAlts() {
        const load = () => {
          if (this.altsLoaded) return;
          this.altsLoaded = true;
          this.canvas.querySelectorAll('template[data-alt]').forEach((template) => {
            template.content.querySelectorAll('img').forEach((img) => (img.loading = 'eager'));
            template.replaceWith(template.content);
          });
          this.measure();
          this.render();
        };
        this.stage.addEventListener('pointerover', (event) => {
          if (event.pointerType !== 'touch') load();
        });
        this.canvas.addEventListener('focusin', load);
      }

      // Mirrors the native scroll position so the progress bar follows the swipe
      bindNativeScroll() {
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.current = this.target = -this.track.scrollLeft;
            this.renderBar();
          });
        }, { passive: true });
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        this.imageObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }

      get minX() {
        return Math.min(0, this.track.clientWidth - this.canvas.offsetWidth);
      }

      // Cache each card's resting centre so the parallax pass never reads layout
      measure() {
        this.layers = this.items.map((item) => ({
          item,
          imgs: [...item.querySelectorAll('.product-desk__media img')],
          center: item.offsetLeft + item.offsetWidth / 2,
          drift: item.offsetWidth * 0.045,
          depth: Number(item.dataset.depth) || 0,
        }));
      }

      setTarget(x) {
        this.target = Math.max(this.minX, Math.min(0, x));
        if (this.native) {
          this.track.scrollLeft = -this.target;
          return;
        }
        if (!this.frame) this.frame = requestAnimationFrame(this.tick);
      }

      tick() {
        this.current += (this.target - this.current) * this.ease;
        if (Math.abs(this.target - this.current) < 0.1) this.current = this.target;
        this.render();
        this.frame = this.current === this.target && !this.dragging ? null : requestAnimationFrame(this.tick);
      }

      render() {
        if (this.native) {
          this.renderBar();
          return;
        }

        this.canvas.style.transform = `translate3d(${this.current}px, 0, 0)`;

        // Photos slide inside their tiles against the drag direction, and tiles on the far
        // layers travel slower and sit smaller, so the desk reads as having depth
        if (!this.reduceMotion) {
          const middle = this.track.clientWidth / 2;
          for (const layer of this.layers) {
            const position = Math.max(-1, Math.min(1, (layer.center + this.current - middle) / middle));
            if (layer.depth) {
              // Capped so wide screens keep the same clearance between tiles
              const lag = -position * Math.min(middle, 720) * 0.1 * layer.depth;
              layer.item.style.transform = `translate3d(${lag.toFixed(2)}px, 0, 0) scale(${1 - 0.07 * layer.depth})`;
            }
            const drift = `translate3d(${(-position * layer.drift).toFixed(2)}px, 0, 0) scale(1.1)`;
            for (const img of layer.imgs) img.style.transform = drift;
          }
        }

        this.renderBar();
      }

      renderBar() {
        if (!this.bar) return;
        const ratio = Math.min(1, this.track.clientWidth / this.canvas.offsetWidth);
        const progress = this.minX ? this.current / this.minX : 0;
        this.bar.style.setProperty('--bar-w', `${ratio * 100}%`);
        this.bar.style.setProperty('--bar-x', `${ratio < 1 ? ((progress * (1 - ratio)) / ratio) * 100 : 0}%`);
      }

      bindDrag() {
        const canvas = this.canvas;
        let startX = 0;
        let startTarget = 0;
        let lastX = 0;
        let lastTime = 0;
        let velocity = 0;

        canvas.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;
          this.dragging = true;
          this.moved = 0;
          startX = lastX = event.clientX;
          lastTime = performance.now();
          startTarget = this.target;
          velocity = 0;
        });

        canvas.addEventListener('pointermove', (event) => {
          if (!this.dragging) return;
          if (!canvas.classList.contains('is-dragging') && Math.abs(event.clientX - startX) > 4) {
            canvas.classList.add('is-dragging');
            // Capture can fail if the pointer is already gone; dragging still works without it
            try {
              canvas.setPointerCapture(event.pointerId);
            } catch {}
          }
          const now = performance.now();
          const delta = event.clientX - lastX;
          // Smoothed pointer velocity in px per ms, used for the throw on release
          velocity = velocity * 0.6 + (delta / Math.max(1, now - lastTime)) * 0.4;
          lastX = event.clientX;
          lastTime = now;
          this.moved += Math.abs(delta);
          this.setTarget(startTarget + (event.clientX - startX));
        });

        const release = () => {
          if (!this.dragging) return;
          this.dragging = false;
          canvas.classList.remove('is-dragging');
          if (performance.now() - lastTime < 80 && !this.reduceMotion) {
            // Short, capped throw so a flick glides a little instead of flying across the desk
            const throwDistance = Math.max(-240, Math.min(240, velocity * 140));
            this.setTarget(this.target + throwDistance);
          }
        };
        canvas.addEventListener('pointerup', release);
        canvas.addEventListener('pointercancel', release);

        // Swallow the click that ends a drag so it does not open a product
        canvas.addEventListener('click', (event) => {
          if (this.moved > 6) event.preventDefault();
        }, true);
      }

      bindWheel() {
        this.stage.addEventListener('wheel', (event) => {
          if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
          event.preventDefault();
          // Trackpad flicks fire long bursts of large deltas; damp each step and keep the
          // target on a short leash ahead of the glide so the desk never races away
          const delta = event.deltaX * (event.deltaMode === 1 ? 16 : 1);
          const step = Math.max(-60, Math.min(60, delta)) * 0.45;
          const lead = this.track.clientWidth * 0.25;
          const next = Math.max(this.current - lead, Math.min(this.current + lead, this.target - step));
          this.setTarget(next);
        }, { passive: false });
      }

      // Keep keyboard focus visible by panning the focused product into view
      bindFocus() {
        this.canvas.addEventListener('focusin', (event) => {
          const item = event.target.closest('.product-desk__item');
          if (!item) return;
          const intro = this.querySelector('.product-desk__intro');
          const offset = getComputedStyle(intro).position === 'absolute' ? intro.offsetWidth : 24;
          this.stage.scrollLeft = 0;
          this.setTarget(-(item.offsetLeft - offset));
        });
      }

      // The progress bar doubles as a scrollbar: press to jump, drag to scrub
      bindBar() {
        const bar = this.bar;
        let grabOffset = 0;
        let scrubbing = false;

        const scrubTo = (clientX) => {
          const rect = bar.getBoundingClientRect();
          const ratio = Math.min(1, this.track.clientWidth / this.canvas.offsetWidth);
          const travel = rect.width * (1 - ratio);
          if (!travel) return;
          const progress = (clientX - rect.left - grabOffset) / travel;
          this.setTarget(Math.max(0, Math.min(1, progress)) * this.minX);
        };

        bar.addEventListener('pointerdown', (event) => {
          if (event.button !== 0) return;
          event.preventDefault();
          const rect = bar.getBoundingClientRect();
          const ratio = Math.min(1, this.track.clientWidth / this.canvas.offsetWidth);
          const thumbWidth = rect.width * ratio;
          const thumbLeft = rect.left + (this.minX ? this.current / this.minX : 0) * (rect.width - thumbWidth);
          const insideThumb = event.clientX >= thumbLeft && event.clientX <= thumbLeft + thumbWidth;
          grabOffset = insideThumb ? event.clientX - thumbLeft : thumbWidth / 2;
          scrubbing = true;
          bar.classList.add('is-dragging');
          scrubTo(event.clientX);
          try {
            bar.setPointerCapture(event.pointerId);
          } catch {}
        });

        bar.addEventListener('pointermove', (event) => {
          if (scrubbing) scrubTo(event.clientX);
        });

        const release = () => {
          scrubbing = false;
          bar.classList.remove('is-dragging');
        };
        bar.addEventListener('pointerup', release);
        bar.addEventListener('pointercancel', release);
      }
    }

    customElements.define('product-desk', ProductDesk);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  // Every card is on screen at once in a grid, so videos are gated on visibility:
  // only cards actually in view play, and they pause again once they scroll away.
  class FeatureGrid extends HTMLElement {
    connectedCallback() {
      if (this.dataset.autoplay !== 'true') return;

      this.videos = Array.from(this.querySelectorAll('video'));
      if (!this.videos.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const video = entry.target;
            if (entry.isIntersecting) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          }
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.25 }
      );

      for (const video of this.videos) {
        video.removeAttribute('autoplay');
        video.pause();
        this.observer.observe(video);
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('feature-grid')) {
    customElements.define('feature-grid', FeatureGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-specs"] && !Shopify.designMode) return;
  try {
    
  // Smooth scroll from the accordion link to the specs table (instant with reduced motion).
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.product-specs-link');
    const target = link && document.getElementById('ProductSpecs');
    if (!target) return;
    event.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    history.replaceState(null, '', '#ProductSpecs');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-image"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shoppable-image')) {
    class ShoppableImage extends HTMLElement {
      connectedCallback() {
        this.hotspots = [...this.querySelectorAll('[data-hotspot]')];

        this.hotspots.forEach((hotspot) => {
          hotspot.querySelector('button').addEventListener('click', () => this.toggle(hotspot));
          hotspot.addEventListener('pointerenter', () => this.place(hotspot));
          hotspot.addEventListener('focusin', () => this.place(hotspot));
        });

        this.onDocumentClick = (event) => {
          if (!event.target.closest('[data-hotspot]')) this.closeAll();
        };
        this.onKeydown = (event) => {
          if (event.key !== 'Escape') return;
          const open = this.querySelector('[data-hotspot].is-open');
          this.closeAll();
          open?.querySelector('button').focus();
        };
        this.onBlockSelect = (event) => {
          const hotspot = event.target.closest('[data-hotspot]');
          if (!hotspot) return;
          this.closeAll();
          this.open(hotspot);
        };
        this.onBlockDeselect = () => this.closeAll();

        document.addEventListener('click', this.onDocumentClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      toggle(hotspot) {
        const shouldOpen = !hotspot.classList.contains('is-open');
        this.closeAll();
        if (shouldOpen) this.open(hotspot);
      }

      open(hotspot) {
        this.place(hotspot);
        hotspot.classList.add('is-open');
        hotspot.querySelector('button').setAttribute('aria-expanded', 'true');
      }

      closeAll() {
        this.hotspots.forEach((hotspot) => {
          hotspot.classList.remove('is-open');
          hotspot.querySelector('button').setAttribute('aria-expanded', 'false');
        });
      }

      // Keeps the card inside the section horizontally and flips it below the
      // dot when there is not enough image above it.
      place(hotspot) {
        const card = hotspot.querySelector('.shoppable-image__card');
        const media = this.querySelector('.shoppable-image__media');
        if (!card || !media) return;

        const gutter = 12;
        const bounds = this.getBoundingClientRect();
        const point = hotspot.getBoundingClientRect();
        const width = card.offsetWidth;
        const left = point.left - width / 2;
        const clamped = Math.min(Math.max(left, bounds.left + gutter), bounds.right - gutter - width);
        hotspot.style.setProperty('--card-shift', `${Math.round(clamped - left)}px`);

        const spaceAbove = point.top - media.getBoundingClientRect().top;
        hotspot.classList.toggle('is-below', spaceAbove < card.offsetHeight + 30);
      }
    }

    customElements.define('shoppable-image', ShoppableImage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-spotlight"] && !Shopify.designMode) return;
  try {
    
  class VideoSpotlight extends HTMLElement {
    connectedCallback() {
      this.videos = this.querySelectorAll('video');
      this.toggle = this.querySelector('[data-sound-toggle]');

      if (!this.videos.length || !this.toggle) return;

      // Store the bound handler so it can be removed on disconnect.
      this.onToggle = this.#onToggle.bind(this);
      this.toggle.addEventListener('click', this.onToggle);
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.onToggle);
    }

    async #onToggle() {
      const soundOn = !this.classList.contains('video-spotlight--sound-on');

      // Only the visible video carries audio; the off-breakpoint one stays
      // muted so the desktop and mobile tracks never overlap.
      for (const video of this.videos) {
        const visible = video.offsetParent !== null;
        video.muted = !(soundOn && visible);

        if (soundOn && visible) {
          try {
            await video.play();
          } catch (error) {
            // play() may reject if interrupted; the click already counts as a gesture.
          }
        }
      }

      this.classList.toggle('video-spotlight--sound-on', soundOn);
      this.toggle.setAttribute('aria-pressed', String(soundOn));
    }
  }

  if (!customElements.get('video-spotlight')) {
    customElements.define('video-spotlight', VideoSpotlight);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-addo-shop"] && !Shopify.designMode) return;
  try {
    
  /**
   * Links a benefit card to the product trust row: a card's drawer button
   * opens the trust item with the same label, reusing that item's drawer and
   * content. The button stays hidden when no such item is on the page.
   */
  class WhyAddoShop extends HTMLElement {
    connectedCallback() {
      for (const button of this.querySelectorAll('[data-trust-open]')) {
        const opener = this.findTrustOpener(button.dataset.trustOpen);
        if (!opener) continue;
        button.hidden = false;
        button.addEventListener('click', () => opener.click());
      }
    }

    findTrustOpener(label) {
      const wanted = this.normalize(label);
      for (const item of document.querySelectorAll('product-trust-row .product-trust__item')) {
        const text = item.querySelector('.product-trust__text');
        if (text && this.normalize(text.textContent) === wanted) {
          return item.closest('[data-trust-row]');
        }
      }
      return null;
    }

    normalize(value) {
      return value.replace(/\s+/g, ' ').trim().toLocaleLowerCase('tr');
    }
  }

  if (!customElements.get('why-addo-shop')) {
    customElements.define('why-addo-shop', WhyAddoShop);
  }

  } catch(e) { console.error(e); }
})();
})();
